import { render, staticRenderFns } from "./AccountDetailsCard.vue?vue&type=template&id=76e1a9c1&"
import script from "./AccountDetailsCard.vue?vue&type=script&lang=js&"
export * from "./AccountDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports